<div class="florderList">
  <div
    class="florder"
    [ngStyle]="{ backgroundColor: findBackgroundColor(florderInfo.customerId), color: findColor(florderInfo.customerId) }"
    placement="top-left"
    *ngFor="let florderInfo of day.florderInfos | slice: 0:SLICE_NUMBER"
    (mouseenter)="mouseenter(florderInfo, $event)"
    (mouseleave)="mouseleave(florderInfo)"
  >
    <div *ngIf="showTooltip === florderInfo" class="florder-tooltip" [ngStyle]="tooltipStyle">
      <ng-container *ngTemplateOutlet="tooltipRef; context: { $implicit: florderInfo, tooltipBoundingBoxChange: tooltipBoundingBoxChangeBnd }"></ng-container>
    </div>
    <div>
      {{ florderInfo.etmOrderNumber }}
    </div>
  </div>
  <span class="more" *ngIf="day.totalNumberOfOrders > SLICE_NUMBER">{{ day.totalNumberOfOrders - SLICE_NUMBER }} {{ 'CALENDAR.MORE_ORDERS' | translate }}</span>
</div>
